module.exports = __webpack_public_path__ + "static/img/fivestar_esp.50c7dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivestar_esp.png
// module id = C2Gp
// module chunks = 1